import { HttpService } from '@/app/shared/services/http.service';
import { env } from '@/environments';
import {
  RefundExternal,
  RefundSettingsModel,
  StatementModel,
  CovenantModel,
} from '@/app/shared/models';
import { refsService } from '../../refs.service';

export class RefundService extends HttpService {
  public async loadRefundSettings(
    Filter?: string,
    limit = 999
  ): Promise<RefundSettingsModel[]> {
    return await this.get<RefundSettingsModel[]>(
      `${env.financialUri}/Settings/refunds`,
      {
        params: { Filter, limit },
        headers: { tenantId: refsService.modules.company.account.Id },
      }
    ).then(({ data }) => data);
  }

  public async loadStatements(
    Filter?: string,
    limit = 999
  ): Promise<StatementModel[]> {
    return await this.get<StatementModel[]>(`${env.financialUri}/Statements`, {
      params: { Filter, limit },
      headers: { tenantId: refsService.modules.company.account.Id },
    }).then(({ data }) => data);
  }

  public async loadCovenant(id: string): Promise<CovenantModel> {
    return await this.get<CovenantModel>(
      `${env.financialUri}/Settings/Covenants/${id}`
    ).then(({ data }) => data);
  }

  public async loadRefundExternalList(filter?: string, limit = 999) {
    return (
      await this.get<RefundExternal[]>(
        `${env.financialUri}/Settings/externalRefundCovenant`,
        {
          params: { limit, filter },
        }
      )
    ).data;
  }
}
